import React from 'react'
import isEmpty from 'lodash/isEmpty'
import styled from 'styled-components'
import { mq, spacing, fontSize, color } from 'core/theme'
import { usePageContext } from 'core/helpers/pageContext'
import Link from 'core/components/LocaleLink'
import Button from 'core/components/Button'
import PageLabel from './PageLabel'
import config from 'Config/config.yml'
import T from 'core/i18n/T'
import ArrowLeft from '../icons/ArrowLeft'
import ArrowRight from '../icons/ArrowRight'
import MediaPartner from '../../../surveys/rn2022/logo/MediaPartner'

const PageFooter = () => {
    const context = usePageContext()

    return (
        <Container>
            <Nav>
                {context.previous && !isEmpty(context.previous) ? (
                    <PreviousLink
                        as={Link}
                        className="PageFooter__Link PageFooter__Link--previous"
                        to={context.previous.path}
                    >
                        <ArrowLeft />
                        <LinkLabel>
                            <T k="page.previous" />
                        </LinkLabel>{' '}
                        <PageLabel page={context.previous} />
                    </PreviousLink>
                ) : (
                    <div />
                )}
                {context.next && !isEmpty(context.next) && (
                    <NextLink
                        as={Link}
                        className="PageFooter__Link PageFooter__Link--next Button"
                        to={context.next.path}
                    >
                        <LinkLabel>
                            <T k="page.next" />
                        </LinkLabel>{' '}
                        <PageLabel page={context.next} />
                        <ArrowRight />
                    </NextLink>
                )}
            </Nav>
            <Notes>
                <MediaPartner />
                <div>
                    © 2024 Software Mansion, courtesy of Devographics{' '}
                    <T k="general.leave_issue" values={{ link: config.issuesUrl }} html={true} />{' '}
                </div>
            </Notes>
        </Container>
    )
}

const Container = styled.footer`
    @media ${mq.small} {
        margin-top: ${spacing(4)};
    }
    @media ${mq.mediumLarge} {
        margin-top: ${spacing(6)};
    }
`

const Nav = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    #arrowLeft {
        margin-right: 5px;
    }
    #arrowRight {
        margin-left: 5px;
    }
    @media ${mq.mediumLarge} {
        justify-content: space-between;
    }
    @media ${mq.small} {
        flex-direction: column;
    }
    @media ${mq.xxLarge} {
        padding: 0 ${spacing(6)};
    }
    .Button {
        border: none;
    }
`

const Notes = styled.div`
    font-size: ${fontSize('small')};
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid ${color('border')};

    @media ${mq.small} {
        margin-top: ${spacing(4)};
        flex-direction: column;
    }
    @media ${mq.mediumLarge} {
        margin-top: ${spacing(6)};
        padding: ${spacing(1)};
    }
`

const FooterLink = styled(Button)`
    justify-content: center;
    align-items: center;
    display: flex;
    font-size: 18px;
    background: ${color('textAlt')};
    @media ${mq.small} {
        text-align: center;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
    }
    &:hover {
        background: ${color('backgroundAlt')};
    }
`

const PreviousLink = styled(FooterLink)`
    flex: 1 1 min-content;
    color: white !important;
    @media ${mq.mediumLarge} {
        flex: 0 1 max-content;
    }
`

const NextLink = styled(FooterLink)`
    flex: 1 1 min-content;
    color: white !important;
    @media ${mq.mediumLarge} {
        flex: 0 1 max-content;
    }
`

const LinkLabel = styled.span`
    padding-right: 8px;
    @media ${mq.small} {
        display: none;
    }
`

export default PageFooter
